import EditBlocker from './EditBlocker';
import { useLeaseQuery } from '../../utils/queries';

type OwnProps = {
  leaseId: string;
  onClose(): void;
};

export default function CancelSigningConfirmation({ leaseId, onClose }: OwnProps) {
  const leaseQuery = useLeaseQuery(leaseId);
  const lease = leaseQuery.data;

  function onCancelEdit() {
    onClose();
  }

  if (!lease) {
    return null;
  }

  return <EditBlocker isWizardView lease={lease} onCancelEdit={onCancelEdit} />;
}
